import { BaseDto } from "../base/baseDto.model";
import { IBonificacionDto } from "./iBonificacionDto.model";

export class BonificacionDto extends BaseDto implements IBonificacionDto{
  public tipoBonificacion: BaseDto = new BaseDto
  public detalle!: string
}


